import type { MatchMode } from '@/components/tree-dnd/tree-dnd-types';
import { useI18nContext } from '@/i18n/i18n-react';
import { cn } from '@/lib/utils';

interface MatchModeInlineHelpProps {
  match: MatchMode;
  onChange: (match: MatchMode) => void;
  before: string;
  afterAny: string;
  afterAll: string;
  className?: string;
}

export function MatchModeInlineHelp({
  match,
  onChange,
  before,
  afterAny,
  afterAll,
  className,
}: MatchModeInlineHelpProps) {
  const { LL } = useI18nContext();

  const matchLabel =
    match === 'all'
      ? LL.audiences.filters.matchAll()
      : LL.audiences.filters.matchAny();
  const after = match === 'all' ? afterAll : afterAny;

  const toggle = () => {
    onChange(match === 'all' ? 'any' : 'all');
  };

  return (
    <p className={cn(className)}>
      {before}{' '}
      <button
        type="button"
        onClick={toggle}
        aria-label={LL.audiences.filters.matchMode()}
        aria-pressed={match === 'all'}
        className="inline-flex items-center rounded-md border border-input bg-background px-1.5 py-0.5 text-sm font-medium text-foreground transition-colors hover:border-primary hover:bg-primary hover:text-primary-foreground"
      >
        {matchLabel}
      </button>{' '}
      {after}
    </p>
  );
}
